import { ConfigService, SystemUrlService } from "@xo/client-common";

export class Type4FractionUrlService extends SystemUrlService {
    constructor(system: string, configService: ConfigService) {
        super(system, "SpecApp", "Type4Fraction", configService);
    }
}
